import { Box } from 'braid-design-system';
import React, { useContext, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import AnalyticsContext from 'src/analytics/AnalyticsContext';
import type { RecommendedJobsAnalytics } from 'src/analytics/adapter/recommendedJobs';

import 'intersection-observer';

interface CareerInsightsType {
  content: string | undefined;
  lmisSnippet?: any;
}

const createMarkup = (html: string) => ({
  __html: html,
});

const CareerInsight = ({ lmisSnippet, content }: CareerInsightsType) => {
  const { learningSnippetViewed, learningSnippetClicked } = useContext(
    AnalyticsContext,
  ) as RecommendedJobsAnalytics;

  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) {
      learningSnippetViewed({ lmisSnippet });
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [inView]);

  return (
    <Box ref={ref}>
      {content && (
        <div
          data-automation="dynamic-lmis"
          dangerouslySetInnerHTML={createMarkup(content)}
          onClick={() => learningSnippetClicked({ lmisSnippet })}
        />
      )}
    </Box>
  );
};

export default CareerInsight;
